import React, { useEffect, useState } from 'react';
import { FaFileAlt } from 'react-icons/fa'; 
import '../styles/CardStyles.css';

function TotalPostsCard() {
  const [totalPosts, setTotalPosts] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/data`);
        const data = await response.json();

        if (data && Array.isArray(data)) {
          setTotalPosts(data.length);
        }
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="card">
      <FaFileAlt size={40} color="#5a7302" className="card-icon" />
      <h3>Total de Postagens Coletadas</h3>
      <p>{totalPosts}</p>
    </div>
  );
}

export default TotalPostsCard;
